import { render, staticRenderFns } from "./subAccountDetail.vue?vue&type=template&id=82ffcb5e&scoped=true&"
import script from "./subAccountDetail.vue?vue&type=script&lang=js&"
export * from "./subAccountDetail.vue?vue&type=script&lang=js&"
import style0 from "./subAccountDetail.vue?vue&type=style&index=0&id=82ffcb5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82ffcb5e",
  null
  
)

export default component.exports